import { Injectable } from '@angular/core';
import { Parent } from '@core/models/entities/parent.models';
import { HttpApi } from './http.api';
import { Observable } from 'rxjs';
import { UpdateFamilyPayload } from '@features/families/models/family-update.models';
import { WlcmPaginatedData, WlcmQueryParams } from '@wlcm/common';

const feature: string = 'parent';

@Injectable({ providedIn: 'root' })
export class ParentApi {
  constructor(private readonly httpApi: HttpApi) {}

  getMy(): Observable<Parent> {
    return this.httpApi.get(`${feature}/my`);
  }

  getPaginated(params: WlcmQueryParams): Observable<WlcmPaginatedData<Parent>> {
    return this.httpApi.get(feature, { params });
  }

  addFamily(payload: UpdateFamilyPayload): Observable<void> {
    return this.httpApi.post(`${feature}/add`, payload);
  }

  patch(id: string, payload: { automated_emails: boolean }): Observable<Parent> {
    return this.httpApi.patch(`${feature}/${id}`, payload);
  }

  removeFamily(id: string): Observable<void> {
    return this.httpApi.delete(`${feature}/${id}`);
  }
}
